import VerifyCard from './Verify';

export default VerifyCard;
